import {
  toPaymentStatus,
  toPayType,
} from "features/purchaseHistory/purchaseHistoryOrderValues";
import { getPaymentType } from "utility/getPaymentType";

import { PAYMENT_STATUS } from "../../constants/PaymentStatus";

import type { OrderData } from "../../types/OrderData";
import type { LegacyPortalPurchaseHistoryOrder } from "@spwn-portal/grpc";

/**
 * 購入履歴APIの注文を注文情報の表示値へ。
 * 注文日時はFirestore直読み側の値（Timestampのseconds）に合わせて秒で持つ
 */
export const convertOrderToOrderData = (
  order: LegacyPortalPurchaseHistoryOrder
): OrderData => ({
  orderId: order.displayOrderNumber,
  purchasedAt:
    order.createdAt === undefined
      ? 0
      : Math.floor(Number(order.createdAt) / 1000),
  purchasedCount: order.purchasedCount,
  purchasedType: getPaymentType(toPayType(order.payType)),
  paymentStatus: toPaymentStatus(order.status) ?? PAYMENT_STATUS.UNPROCESS,
  totalPrice: order.totalPrice,
  shippingFee: order.shippingFee,
  serviceFee: order.serviceFee ?? 0,
  settlementFee: order.settlementFee ?? 0,
});
